import React from 'react';
import IMG1 from '../../assets/Ecomzy.png';
import IMG2 from '../../assets/payment.png';
import IMG3 from '../../assets/youtube.png';
import IMG4 from '../../assets/portfolio.png';
import IMG5 from '../../assets/weather.png';
import IMG6 from '../../assets/Razorpay.png';

import './portfolio.css';

const Portfolio = () => {
  const soloProjects = [
    {
      id: 1,
      title: 'Ecomzy',
      img: IMG1,
      description:
        '"Ecomzy is a dynamic e-commerce website where users can add items to their cart, remove them, and easily manage login/logout.".',
      technologies: 'React | Javascript | Tailwind',
      // github: 'https://github.com/Meri-MG/school',
    },
    {
      id: 2,
      title: 'Payment Application',
      img: IMG2,
      description:
        'Implemented Full-stack payment application Capabilities: Conduct financial transactions locally on database, Monitor account balance, Establish an account, Explore other users',
      technologies: 'React | Express | Tailwind | MongoDb',
      // github: 'https://github.com/Meri-MG/Fakestore---react',
    },
    {
      id: 3,
      title: 'Youtube Media Application',
      img: IMG3,
      description: 'Developed YouTube media application using React and Material UI,integrating Rapid API for data fetching. Responsive design, videoplayback, and search functionality implemented. Watch video with an add free experience',
      technologies: 'React | JavaScript | RapidApi ',
      // github: 'https://github.com/Meri-MG/To-Do-List',
    },
    {
      id: 4,
      title: 'Personal Portfolio Website',
      img: IMG4,
      description:
        'Developed personal portfolio website using React and Tailwind CSS.Responsive design, project showcases, contact form, and smooth navigation implemented for optimal user experience',
      technologies: 'React | JavaScript | CSS',
      // github: 'https://github.com/Meri-MG/shelter',
    },
    {
      id: 4,
      title: 'Wather web Application',
      img: IMG5,
      description:
        'Interactive weather application capable of telling weather of your location and any location around the world',
      technologies: 'HTML | Tailwind | JS ',
      // github: 'https://github.com/Laraibkhan13/Weather-App-',
    },
    {
      id: 6,
      title: 'RazorPay frontend Clone',
      img: IMG6,
      description:
        'Razorpay clone,it is a simple web application built using HTML and CSS that replicates the basic user interface of the original Razorpay',
      technologies: 'HTMl | CSS | JS | Tailwind',
      github: 'https://github.com/Laraibkhan13/RazorPay-clone',
    },
  ];

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {soloProjects.map((pro) => (
          <article className="portfolio__item" key={pro.id}>
            <div className="portfolio__item-image">
              <img src={pro.img} alt={pro.title} />
            </div>
            <div className="portfolio__item-content">
              <h3>{pro.title}</h3>
              <p>{pro.description}</p>
              <p>{pro.technologies}</p>
            </div>
            <div className="portfolio__item-cta">
{/*               
              /*<a
                href={pro.github}
                target="_blank"
                className="btn"
                rel="noreferrer"
              >
                GitHub
              </a>
              <a
                href={pro.link}
                target="_blank"
                className="btn btn-primary"
                rel="noreferrer"
              >
                Visit Website
              </a>
               */}

            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
